import { Game } from './Game'
import "./Includes/import-jquery"
import "./Includes/jquery-ui.min.js"
import "./Includes/jquery.ui.touch-punch.min.js"
import { IMAXAClient } from './Logic/Links/IMAXA/IMAXAClient';
import { DEVClient } from './Logic/Links/IMAXA/DEVClient';
import { Constants } from './Utils/Constants';
import { getBool, GetParameterByName, isURL } from './Utils/HelperFunction';
import { Logic } from './Logic/Logic';

export class Client {

	public static game: Phaser.Game;	//phaser game instance (rendering & sounds)
	public static logic: Logic;   		//game logic loop handling class
	public static remote: IMAXAClient;  //server communication handling class

	public static slot: boolean = (GetParameterByName("platform") == "slot");
	public static exiting: boolean = false;
	public secure = getBool(GetParameterByName("secure", "1"));		//debug - use ws instead of wss to connect to yserver
	public autoplay = getBool(GetParameterByName("autoplay", "0"));	//debug - automatically place random bets on bets open
	public yserverQuery = decodeURIComponent(GetParameterByName("server"));
	public address;

	constructor(gameTitle: string, config: Phaser.Types.Core.GameConfig, logicClass: typeof Logic) {
		document.title = gameTitle;

		// when the page is loaded, create our main components--
		window.addEventListener("load", () => {
			//--create render & sound handling class
			Client.game = new Game(config).phaserInstance;
			//--------------------------------------------------

			//--create server communication handling class------
			if (Constants.DEVELOPER_MODE) {
				this.address = "wss://" + window.location.hostname + ":7997/";
				Client.remote = new DEVClient(this.address);
			}
			else {
				let tempString = this.yserverQuery;
				//if server url is not valid we assume its base64, try to decode it and crash
				if (!isURL(this.yserverQuery))
					try {
						this.yserverQuery = atob(this.yserverQuery);
					}
					catch (e) {
						this.yserverQuery = tempString;
					}

				if (this.secure)
					this.address = "wss://" + this.yserverQuery;
				else
					this.address = "ws://" + this.yserverQuery;

				Client.remote = new IMAXAClient(this.address);
			}
			//--------------------------------------------------

			//--create our game logic loop handling class-------
			Client.logic = new logicClass(this.autoplay);
			//--------------------------------------------------

			//Once all main components are created, we start connecting to yserver
			Client.remote.CreateNewSocket();
		});
	}
}